define("calendar/components/calendar/onboarding/wizards/teams-setup", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "tracked-built-ins", "later/utils/constants", "later/utils/fetch"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _object, _runloop, _service, _component2, _tracking, _emberConcurrency, _trackedBuiltIns, _constants, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _displaySuccessBanner, _validateData, _emailFormatIsValid, _hasDuplicateEmailEntries, _initializeInvitesObject;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"tracked-built-ins",0,"later/utils/constants",0,"later/utils/fetch"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

  function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

  function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Wizard @closable={{true}} @inline={{false}} @onFinish={{@transition}} @primaryClass="tOB--modalBg" as |wizard|>
    <wizard.slide @primaryClass="tOB--modalCard o--modalCard" as |slide|>
      <slide.body>
        {{! header }}
        <div class="o--modalHeader u--flex u--flex__col u--flex__alignItems--center">
          <h2 class="tOB--wizard__title u--text--lg u--m__b__xs">
            {{t "onboarding.teams_setup.title"}}
          </h2>
          <p class="u--text--light u--m__b__0">{{t "onboarding.teams_setup.subtitle" numberOfUsers=this.totalUsers}}</p>
        </div>
        {{! body }}
        <div class="tOB--team__modalBody o--modalBody" {{perfect-scroll}}>
          <form class="o--formWrapper--lg u--hide--mf u--m__b">
            <label class="tOB--team__inputWrapper">
              <Input
                @type="email"
                @value=""
                class="o--form__input tOB--team__input is--active"
                disabled={{true}}
                placeholder={{this.ownerEmail}}
              />
              <i class="tOB--team__formIcon">{{svg-jar "overview" class="o--icon o--icon--sm"}}</i>
              <span class="u--block u--text--light u--text--sm tOB--team__formNote">
                {{t "onboarding.teams_setup.account_owner"}}
              </span>
            </label>
          </form>
          {{#each this.invites as |invite|}}
            <form aria-label={{invite.id}} class="o--formWrapper--lg u--hide--mf u--m__b" {{on "submit" this.onSubmit}}>
              <label class="tOB--team__inputWrapper">
                <Input
                  @type="email"
                  @value={{invite.value}}
                  class={{concat-classes
                    "o--form__input tOB--team__input"
                    (if (eq invite.status this.INVITE_STATUS.SUCCESS) "is--successful")
                    (if (eq invite.status this.INVITE_STATUS.WARNING) "has--warning o--form__select--hasWarning")
                    (if (eq invite.status this.INVITE_STATUS.ERROR) "has--error o--form__select--hasError")
                  }}
                  disabled={{eq invite.status this.INVITE_STATUS.SUCCESS}}
                  placeholder={{t "shared_phrases.enter_email"}}
                  {{on "input" (fn this.validateData invite.id)}}
                />
                <i class="tOB--team__formIcon">{{svg-jar "overview" class="o--icon o--icon--sm"}}</i>
                {{! Success message }}
                {{#if (eq invite.status this.INVITE_STATUS.SUCCESS)}}
                  <span class="u--block u--text--success u--text--sm tOB--team__formNote">
                    {{t "onboarding.teams_setup.invited"}}
                    <i class="">{{svg-jar "check" class="o--icon o--icon--xs o--icon--success"}}</i>
                  </span>
                {{/if}}
              </label>
              {{! Error message }}
              <span
                class={{concat-classes
                  "o--form__helpText u--m__t__xs"
                  (if (eq invite.status this.INVITE_STATUS.WARNING) "has--warning is--warning")
                  (if (eq invite.status this.INVITE_STATUS.ERROR) "has--error is--error")
                }}
              >
                {{#if (eq invite.status this.INVITE_STATUS.WARNING)}}
                  <span class="u--flexInline u--flex__alignItems--center">
                    <i class="u--m__r__sm u--m__l__xs">{{svg-jar "warning" class="o--icon"}}</i>
                    {{t "onboarding.teams_setup.email_already_a_later_user"}}
                  </span>
                {{/if}}
                {{#if (eq invite.status this.INVITE_STATUS.ERROR)}}
                  {{t "shared_phrases.enter_valid_email"}}
                {{/if}}
              </span>
            </form>
          {{/each}}
        </div>
        {{! footer }}
        <footer class="u--relative o--modalFooter">
          {{#if this.hasDuplicateEmail}}
            <span class="o--form__helpText u--m__t__0 has--warning is--warning">
              <span class="u--flexInline u--flex__alignItems--center">
                <i class="u--m__r__xs">{{svg-jar "warning" class="o--icon"}}</i>
                {{t "onboarding.teams_setup.duplicate_email_warning"}}
              </span>
            </span>
          {{/if}}
          <p class="u--text__light">
            {{t "onboarding.teams_setup.invite_more_users_later"}}
            <Shared::Link
              @class="u--m__l"
              @href="https://help.later.com/hc/en-us/articles/360043139153-Add-Users-to-an-Access-Group"
              @openInNewTab={{true}}
              @text={{t "shared_phrases.learn_how"}}
            />
          </p>
          <div class="tOB--team__footer">
            <slide.finishButton
              @buttonClass="o--btn o--btn--mute"
              @finishWizard={{@transition}}
              @isLastSlide={{true}}
              @size="large"
              @text={{t "shared_phrases.skip_for_now"}}
              @variant="none"
              {{track "skip-invite-user" "click"}}
            />
            <Shared::Ui::Button
              @isDisabled={{this.isDisabled}}
              @onClick={{perform this.inviteUsers}}
              @size="large"
              @text={{t "shared_phrases.invite_users"}}
              type="button"
              {{track "invited-user-in-onboarding" "click"}}
            />
          </div>
        </footer>
  
      </slide.body>
    </wizard.slide>
  </Shared::Wizard>
  */
  {
    "id": "VajpOFuD",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@inline\",\"@onFinish\",\"@primaryClass\"],[true,false,[30,1],\"tOB--modalBg\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"slide\"]],null,[[\"@primaryClass\"],[\"tOB--modalCard o--modalCard\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"o--modalHeader u--flex u--flex__col u--flex__alignItems--center\"],[12],[1,\"\\n        \"],[10,\"h2\"],[14,0,\"tOB--wizard__title u--text--lg u--m__b__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"onboarding.teams_setup.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--m__b__0\"],[12],[1,[28,[35,1],[\"onboarding.teams_setup.subtitle\"],[[\"numberOfUsers\"],[[30,0,[\"totalUsers\"]]]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[11,0],[24,0,\"tOB--team__modalBody o--modalBody\"],[4,[38,2],null,null],[12],[1,\"\\n        \"],[10,\"form\"],[14,0,\"o--formWrapper--lg u--hide--mf u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"tOB--team__inputWrapper\"],[12],[1,\"\\n            \"],[8,[39,3],[[24,0,\"o--form__input tOB--team__input is--active\"],[16,\"disabled\",true],[16,\"placeholder\",[30,0,[\"ownerEmail\"]]]],[[\"@type\",\"@value\"],[\"email\",\"\"]],null],[1,\"\\n            \"],[10,\"i\"],[14,0,\"tOB--team__formIcon\"],[12],[1,[28,[35,4],[\"overview\"],[[\"class\"],[\"o--icon o--icon--sm\"]]]],[13],[1,\"\\n            \"],[10,1],[14,0,\"u--block u--text--light u--text--sm tOB--team__formNote\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"onboarding.teams_setup.account_owner\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"invites\"]]],null]],null],null,[[[1,\"          \"],[11,\"form\"],[16,\"aria-label\",[30,4,[\"id\"]]],[24,0,\"o--formWrapper--lg u--hide--mf u--m__b\"],[4,[38,7],[\"submit\",[30,0,[\"onSubmit\"]]],null],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"tOB--team__inputWrapper\"],[12],[1,\"\\n              \"],[8,[39,3],[[16,0,[28,[37,8],[\"o--form__input tOB--team__input\",[52,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"SUCCESS\"]]],null],\"is--successful\"],[52,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"WARNING\"]]],null],\"has--warning o--form__select--hasWarning\"],[52,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"ERROR\"]]],null],\"has--error o--form__select--hasError\"]],null]],[16,\"disabled\",[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"SUCCESS\"]]],null]],[16,\"placeholder\",[28,[37,1],[\"shared_phrases.enter_email\"],null]],[4,[38,7],[\"input\",[28,[37,11],[[30,0,[\"validateData\"]],[30,4,[\"id\"]]],null]],null]],[[\"@type\",\"@value\"],[\"email\",[30,4,[\"value\"]]]],null],[1,\"\\n              \"],[10,\"i\"],[14,0,\"tOB--team__formIcon\"],[12],[1,[28,[35,4],[\"overview\"],[[\"class\"],[\"o--icon o--icon--sm\"]]]],[13],[1,\"\\n\"],[41,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"SUCCESS\"]]],null],[[[1,\"                \"],[10,1],[14,0,\"u--block u--text--success u--text--sm tOB--team__formNote\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"onboarding.teams_setup.invited\"],null]],[1,\"\\n                  \"],[10,\"i\"],[14,0,\"\"],[12],[1,[28,[35,4],[\"check\"],[[\"class\"],[\"o--icon o--icon--xs o--icon--success\"]]]],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"],[1,\"            \"],[10,1],[15,0,[28,[37,8],[\"o--form__helpText u--m__t__xs\",[52,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"WARNING\"]]],null],\"has--warning is--warning\"],[52,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"ERROR\"]]],null],\"has--error is--error\"]],null]],[12],[1,\"\\n\"],[41,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"WARNING\"]]],null],[[[1,\"                \"],[10,1],[14,0,\"u--flexInline u--flex__alignItems--center\"],[12],[1,\"\\n                  \"],[10,\"i\"],[14,0,\"u--m__r__sm u--m__l__xs\"],[12],[1,[28,[35,4],[\"warning\"],[[\"class\"],[\"o--icon\"]]]],[13],[1,\"\\n                  \"],[1,[28,[35,1],[\"onboarding.teams_setup.email_already_a_later_user\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[37,10],[[30,4,[\"status\"]],[30,0,[\"INVITE_STATUS\",\"ERROR\"]]],null],[[[1,\"                \"],[1,[28,[35,1],[\"shared_phrases.enter_valid_email\"],null]],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[4]],null],[1,\"      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,\"footer\"],[14,0,\"u--relative o--modalFooter\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasDuplicateEmail\"]],[[[1,\"          \"],[10,1],[14,0,\"o--form__helpText u--m__t__0 has--warning is--warning\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--flexInline u--flex__alignItems--center\"],[12],[1,\"\\n              \"],[10,\"i\"],[14,0,\"u--m__r__xs\"],[12],[1,[28,[35,4],[\"warning\"],[[\"class\"],[\"o--icon\"]]]],[13],[1,\"\\n              \"],[1,[28,[35,1],[\"onboarding.teams_setup.duplicate_email_warning\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,2],[14,0,\"u--text__light\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"onboarding.teams_setup.invite_more_users_later\"],null]],[1,\"\\n          \"],[8,[39,12],null,[[\"@class\",\"@href\",\"@openInNewTab\",\"@text\"],[\"u--m__l\",\"https://help.later.com/hc/en-us/articles/360043139153-Add-Users-to-an-Access-Group\",true,[28,[37,1],[\"shared_phrases.learn_how\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tOB--team__footer\"],[12],[1,\"\\n          \"],[8,[30,3,[\"finishButton\"]],[[4,[38,13],[\"skip-invite-user\",\"click\"],null]],[[\"@buttonClass\",\"@finishWizard\",\"@isLastSlide\",\"@size\",\"@text\",\"@variant\"],[\"o--btn o--btn--mute\",[30,1],true,\"large\",[28,[37,1],[\"shared_phrases.skip_for_now\"],null],\"none\"]],null],[1,\"\\n          \"],[8,[39,14],[[24,4,\"button\"],[4,[38,13],[\"invited-user-in-onboarding\",\"click\"],null]],[[\"@isDisabled\",\"@onClick\",\"@size\",\"@text\"],[[30,0,[\"isDisabled\"]],[28,[37,15],[[30,0,[\"inviteUsers\"]]],null],\"large\",[28,[37,1],[\"shared_phrases.invite_users\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[2]]]]]],[\"@transition\",\"wizard\",\"slide\",\"invite\"],false,[\"shared/wizard\",\"t\",\"perfect-scroll\",\"input\",\"svg-jar\",\"each\",\"-track-array\",\"on\",\"concat-classes\",\"if\",\"eq\",\"fn\",\"shared/link\",\"track\",\"shared/ui/button\",\"perform\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/teams-setup.hbs",
    "isStrictMode": false
  });

  const INVITE_STATUS = {
    EMPTY: '',
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning'
  };
  let TeamsSetupComponent = (_class = (_displaySuccessBanner = /*#__PURE__*/new WeakMap(), _validateData = /*#__PURE__*/new WeakMap(), _emailFormatIsValid = /*#__PURE__*/new WeakSet(), _hasDuplicateEmailEntries = /*#__PURE__*/new WeakSet(), _initializeInvitesObject = /*#__PURE__*/new WeakSet(), class TeamsSetupComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _initializeInvitesObject);

      _classPrivateMethodInitSpec(this, _hasDuplicateEmailEntries);

      _classPrivateMethodInitSpec(this, _emailFormatIsValid);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);

      _initializerDefineProperty(this, "intl", _descriptor5, this);

      _defineProperty(this, "INVITE_STATUS", INVITE_STATUS);

      _initializerDefineProperty(this, "hasDuplicateEmail", _descriptor6, this);

      _defineProperty(this, "invites", []);

      _defineProperty(this, "inviteUsers", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const requests = yield Promise.allSettled(this.invites.map(invite => {
            if (invite.value.trim() !== '' && invite.status !== INVITE_STATUS.SUCCESS) {
              // POST /api/v2/accounts/:id/invite.json
              return (0, _fetch.fetch)(`/api/v2/accounts/${this.ownerAccountId}/invite.json`, {
                method: 'POST',
                body: {
                  id: this.ownerAccountId,
                  email: invite.value.trim()
                }
              });
            }

            return '';
          }));
          const successfulInvites = [];
          requests.forEach((results, index) => {
            if (results.status === 'rejected') {
              if (results.reason.code === 422) {
                this.invites[index].status = INVITE_STATUS.WARNING;
              } else {
                this.alerts.warning(this.intl.t('shared_phrases.something_went_wrong'));
              }
            }

            if (results.status === 'fulfilled' && results.value !== '') {
              successfulInvites.push(results);
              this.invites[index].status = INVITE_STATUS.SUCCESS;
            }
          });

          if (successfulInvites.length > 0) {
            successfulInvites.forEach(response => {
              this.segment.track('added-team-member', {
                location: 'onboarding',
                team_member_id: response.value?.user?.id || '',
                team_member_email: response.value?.user.email || ''
              });
            });

            _classPrivateFieldGet(this, _displaySuccessBanner).call(this, successfulInvites);
          }

          if (requests.every(result => result.status === 'fulfilled')) {
            this.args.transition();
          }
        }
      }), {
        drop: true
      }, "inviteUsers", null));

      _classPrivateFieldInitSpec(this, _displaySuccessBanner, {
        writable: true,
        value: successfulInvites => {
          switch (successfulInvites.length) {
            case 1:
              return this.alerts.success(this.intl.t('onboarding.teams_setup.success_alert.one', {
                email: successfulInvites[0].value?.user.email
              }));

            case 2:
              return this.alerts.success(this.intl.t('onboarding.teams_setup.success_alert.two', {
                emailOne: successfulInvites[0].value?.user.email,
                emailTwo: successfulInvites[1].value?.user.email
              }));

            default:
              return this.alerts.success(this.intl.t('onboarding.teams_setup.success_alert.more', {
                email: successfulInvites[0].value?.user.email,
                numberOfUsers: 2
              }));
          }
        }
      });

      _classPrivateFieldInitSpec(this, _validateData, {
        writable: true,
        value: id => {
          const editedInvite = this.invites.find(invite => invite.id === id);

          if (!editedInvite) {
            throw new Error(`Could not find invite object with id: ${id}`);
          }

          if (editedInvite.value) {
            _classPrivateMethodGet(this, _emailFormatIsValid, _emailFormatIsValid2).call(this, editedInvite) ? editedInvite.status = INVITE_STATUS.EMPTY : editedInvite.status = INVITE_STATUS.ERROR;
          } else {
            editedInvite.status = INVITE_STATUS.EMPTY;
          }

          this.hasDuplicateEmail = _classPrivateMethodGet(this, _hasDuplicateEmailEntries, _hasDuplicateEmailEntries2).call(this);
        }
      });

      if (this.hasTeamAndCanAddUsers) {
        _classPrivateMethodGet(this, _initializeInvitesObject, _initializeInvitesObject2).call(this);
      } else {
        this.args.transition();
      }
    }

    get hasTeamAndCanAddUsers() {
      return Boolean(this.auth.currentAccount.teamSize !== _constants.ONBOARDING_TEAMSIZE.JUST_ME && this.subscriptions.subscriptionPlan?.canAddUsers);
    }

    get ownerAccountId() {
      return this.auth.currentAccount.id;
    }

    get ownerEmail() {
      return this.auth.currentAccount.canonicalBillingEmail ?? '';
    }

    get totalUsers() {
      return this.subscriptions.subscription?.totalUsers ?? 0;
    }

    get additionalUsers() {
      return this.totalUsers - 1;
    }

    get hasNoNewInvitesToSend() {
      return this.invites.filter(invite => invite.status !== INVITE_STATUS.SUCCESS).every(invite => invite.value.trim() === '');
    }

    get hasErrorOrWarning() {
      return this.invites.some(invite => invite.status === INVITE_STATUS.ERROR || invite.status === INVITE_STATUS.WARNING);
    }

    get isDisabled() {
      return this.hasNoNewInvitesToSend || this.hasErrorOrWarning || this.hasDuplicateEmail;
    }

    get invitesWithValue() {
      return this.invites.filter(invite => invite.value.trim() !== '');
    }

    onSubmit(event) {
      event.preventDefault();

      if (!this.isDisabled) {
        this.inviteUsers.perform();
      }
    }

    validateData(id) {
      (0, _runloop.debounce)(this, _classPrivateFieldGet(this, _validateData), id, 600);
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasDuplicateEmail", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateData", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "validateData"), _class.prototype)), _class);
  _exports.default = TeamsSetupComponent;

  function _emailFormatIsValid2(editedInvite) {
    return _constants.VALID_EMAIL_REGEX.test(editedInvite.value);
  }

  function _hasDuplicateEmailEntries2() {
    const uniqueEmails = new Set(this.invitesWithValue.map(invite => invite.value));
    return uniqueEmails.size !== this.invitesWithValue.length || this.invites.some(invite => invite.value.trim() === this.ownerEmail);
  }

  function _initializeInvitesObject2() {
    [...Array(this.additionalUsers)].forEach((_, idx) => {
      this.invites.pushObject(new _trackedBuiltIns.TrackedObject({
        id: `email-${idx}`,
        value: '',
        status: INVITE_STATUS.EMPTY
      }));
    });
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TeamsSetupComponent);
});